import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ServiceIcon from './ServiceIcon';
import './ServiceAccordionItem.css';

const ServiceAccordionItem = ({ service, isActive, onClick, itemRef, to }) => {
  const { t } = useTranslation();
  const isWebsiteSupport = service?.slug === 'website-support' || Number(service?.legacyId) === 5;

  return (
    <Link
      to={to || '#'}
      ref={itemRef}
      className={`service-selector-card ${isActive ? 'active' : ''} ${isWebsiteSupport ? 'has-support-entry' : ''}`.trim()}
      onClick={onClick}
      aria-current={isActive ? 'page' : undefined}
    >
      <div className="service-selector-card-content">
        <div className="service-selector-icon-wrapper">
          <ServiceIcon name={service.icon} className="service-selector-icon" />
        </div>
        <div className="service-selector-text">
          <h3 className="service-selector-title">{service.title}</h3>
          <p className="service-selector-subtitle">{service.subtitle}</p>
        </div>
      </div>
      {isWebsiteSupport && (
        <span className="service-selector-support-entry">
          <span className="service-selector-support-entry-mark" aria-hidden="true">+</span>
          <span className="service-selector-support-entry-text service-selector-support-entry-text-full">
            {t('serviceUi.accordion.emergency')}
          </span>
          <span className="service-selector-support-entry-text service-selector-support-entry-text-compact">
            {t('serviceUi.accordion.urgent')}
          </span>
        </span>
      )}
      <span className="service-selector-indicator" aria-hidden="true"></span>
    </Link>
  );
};

export default ServiceAccordionItem;

